import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "../../common/translation-context";
import {
  APP_VIEW,
  EXTENSION_COLUMNS,
} from "../../constants/constant";
import {
  fetchLogs,
  searchLogs,
} from "../../store/slices/extension";
import Search from "./search";
import { getUserRole } from "../../utils/utils";
import ToastMessageFunction from "../../common/toast-message-function";
import ExtDataGrid from "../../common/data-grid/ext-data-grid";

export default function LogsPage(props) {
  const dispatch = useDispatch();
  const { translate: t } = useTranslation();
  const userData = useSelector((state) => state.userState.userData);
  const toastManager = ToastMessageFunction();

  const { dropdowns } = useSelector((state) => state.sharedExtension);
  const {
    logs,
    loading: logsLoading,
    error: logsError,
  } = useSelector((state) => state.logsExtension);

  const [logFilterData, setLogFilterData] = useState({});
  const [listOfCountryCode, setListOfCountryCode] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState([]);

  const showToast = useCallback(
    (message, severity) => {
      toastManager.getToast(message, severity);
    },
    [toastManager],
  );

  useEffect(() => {
    dispatch(fetchLogs());
  }, [dispatch]);

  useEffect(() => {
    if (dropdowns.countryCode?.length > 0) {
      setListOfCountryCode(dropdowns.countryCode);
    }
  }, [dropdowns.countryCode]);

  useEffect(() => {
    if (logsError) {
      showToast(logsError, "error");
    }
  }, [logsError, showToast]);

  const getCountryCode = (value) => {
    return value;
  };

  const setAssignmentNo = (value) => {
    setLogFilterData({ ...logFilterData, ...{ assignmentNo: value } });
  };

  const onChangeSerialNo = (value) => {
    setLogFilterData({ ...logFilterData, ...{ serialNo: value } });
  };

  const onRequestStatusChange = (value) => {
    const modifiedRequestStatus = value.map((item) => item.replace(/ /g, "_"));

    setLogFilterData({
      ...logFilterData,
      ...{ requestStatus: modifiedRequestStatus },
    });
  };

  const onCountryChange = (value) => {
    let countryCodes = [];
    setSelectedCountry(value);

    value.forEach((userCountry) => {
      let match = listOfCountryCode.find(
        (country) => country[0] === userCountry,
      );

      if (match) {
        countryCodes.push(match[1]);
      }
    });

    setLogFilterData({
      ...logFilterData,
      ...{ country: getCountryCode(countryCodes) },
    });
  };

  const setDateRange = (value) => {
    setLogFilterData({
      ...logFilterData,
      ...{ startDate: value[0], endDate: value[1] },
    });
  };

  const onClickSearch = () => {
    const filteredData = Object.fromEntries(
    Object.entries(logFilterData).filter(([_, v]) =>
      Array.isArray(v) ? v.length > 0 : v !== "" && v !== null && v !== undefined
    )
  );
    if (Object.keys(filteredData).length > 0) {
      dispatch(searchLogs(filteredData));
    }
  };

  const onClearFilters = () => {
    setLogFilterData({});
    setSelectedCountry([]);
    dispatch(fetchLogs());
  };

  return (
    <div>
      <Search
        searchButton={true}
        view="logs"
        userList={[userData?.userID]}
        requestStatus={dropdowns.requestStatus}
        onClickSearch={onClickSearch}
        onRequestStatusChange={onRequestStatusChange}
        onChangeSerialNo={onChangeSerialNo}
        setAssignmentNo={setAssignmentNo}
        onCountryChange={onCountryChange}
        listOfCountries={dropdowns.countries}
        selectedCountry={selectedCountry}
        setDateRange={setDateRange}
        onClearFilters={onClearFilters}
      />

      <div className="extension-header">
        <h3>
          {t("logs")} ({logs?.length})
        </h3>
      </div>
      <ExtDataGrid
        view={APP_VIEW.LOGS}
        panelView={getUserRole(userData) === "CCM" ? APP_VIEW.CCM : APP_VIEW.BP}
        columns={EXTENSION_COLUMNS}
        rows={logs}
        isLoaderVisible={logsLoading}
        showToast={showToast}
      />
      {toastManager.toast}
    </div>
  );
}
